import * as calendarActions from './actions';
import {ActionType, getType} from 'typesafe-actions';
import {CalendarState, JsonCalendarItem} from './types';
import CalendarItems from "../../domain/CalendarItems";
import DateUtils from "../../utils/Date.utils";
import CalendarItem from "../../domain/CalendarItem";

const defaultState: CalendarState = {
  calendarItems: CalendarItems.empty(),
  thisWeeksCalendarItems: CalendarItems.empty(),
  nextWeeksCalendarItems: CalendarItems.empty(),
  lastUpdatedTimeStamp: DateUtils.getNowAsTimeStamp()
};

export default (state = defaultState, action: ActionType<typeof calendarActions>): CalendarState => {
  switch (action.type) {
    case getType(calendarActions.fetchCalendarItems.success):
      const items: JsonCalendarItem[] = action.payload;
      state.calendarItems.addAll(items.map((item: JsonCalendarItem, index: number) => mapCalendarItem(item, index)));
      return {
        ...state,
        thisWeeksCalendarItems: state.calendarItems.getForThisWeek(),
        nextWeeksCalendarItems: state.calendarItems.getForNextWeek(),
        lastUpdatedTimeStamp: DateUtils.getNowAsTimeStamp()
      };
    default:
      return state;
  }
}

function mapCalendarItem(item: JsonCalendarItem, index: number): CalendarItem {
  const date = DateUtils.parseDate(item.date);
  return new CalendarItem(item.id, item.title, date, item.categories);
}



